module.exports = [{"计算机视觉":"/"},{"自然语言处理":"/"},{"图形学":"/"}]